import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgSuccess = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M21.626 3.214c.424.342.499.973.166 1.41l-11.579 15.22a2.88 2.88 0 0 1-4.69-.109L2.18 14.91a1.024 1.024 0 0 1 .229-1.401.96.96 0 0 1 1.361.235l3.342 4.826a.96.96 0 0 0 1.563.036l11.58-15.22a.96.96 0 0 1 1.37-.171"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgSuccess;
